export const ROUTES = {
	/** PUBLIC */
	LOGIN: "/",
	SIGN_UP: "/registration/sign_up",
	CHECK_SIGNUP_URL: "/check_sign_up",
	RESET_PASSWORD: "/reset_password",
	RESET_PASSWORD_FORM: "/reset_password_form/:restoreId",
	/** PRIVATE */
	HOME: "/dashboard/home",
	SHOW_SETTINGS: "/dashboard/show_settings",
	POSTS: "/dashboard/posts",
	VR_VIDEO: "/dashboard/vr_video",
	BLACKLIST: "/dashboard/blacklists",
	PROFILE_SETTINGS: "/dashboard/profile_settings",
	AGE_VERIFICATION: "/dashboard/age_verification",
	EARNINGS: "/dashboard/earnings",
	BROADCAST_SETTINGS: "/dashboard/broadcast_settings",
	PRIVACY_SETTINGS: "/dashboard/privacy_settings",
	NOTES: "/dashboard/notes",
	INTEGRATIONS: "/dashboard/integrations",
	PAYMENT_SETTINGS: "/dashboard/payment_settings",
};
